import { Menu } from 'ui/menu';
import { FilterMenuTriggerButton } from 'ui/indexPages/filters/FilterMenuTriggerButton';
import { useTranslation } from 'modules/domains/list';

import { useFilterCount, useListTypeMenu } from './hooks';
import { useSelectedMenuOptionIds } from './hooks/useSelectedMenuOptionIds';
import { useHandleMenuOptionSelect } from './hooks/useHandleMenuOptionSelect';

export const Dropdown = () => {
  const { t } = useTranslation();
  const listTypeMenu = useListTypeMenu();
  const filterCount = useFilterCount();
  const selectedOptionIds = useSelectedMenuOptionIds();
  const handleSelectionChange = useHandleMenuOptionSelect();

  return (
    <Menu
      options={[listTypeMenu]}
      defaultSelectedOptionIds={selectedOptionIds}
      handleSelectionChange={handleSelectionChange}
    >
      <FilterMenuTriggerButton
        selectedFilterCount={filterCount}
        triggerText={t('indexPage.filters.dropdown.trigger')}
      />
    </Menu>
  );
};
